import classNames from 'classnames';
import { ReactNode } from 'react';
import { Size } from '../../../constants';

export const Section = (props: Props) => {
  const { id, className, children, fullSpace, includeBottomPadding, size, removeXPadding } = props;

  const getWidthClass = () => {
    switch (size) {
      case Size.xs:
        return 'max-w-lg';
      case Size.sm:
        return 'max-w-3xl';
      case Size.md:
        return 'max-w-5xl';
      case Size.lg:
      default:
        return 'max-w-7xl';
    }
  };

  return (
    <section
      id={id}
      className={classNames(className, getWidthClass(), 'mx-auto', !removeXPadding && 'px-4 sm:px-6 xl:px-8', {
        'full-space': fullSpace,
        'pb-40': includeBottomPadding,
      })}
    >
      {children}
    </section>
  );
};

type Props = {
  id?: string;
  className?: string;
  children: ReactNode;
  fullSpace?: boolean;
  includeBottomPadding?: boolean;
  size?: Size;
  removeXPadding?: boolean;
};
